import { format, parseISO } from 'date-fns';

import { Currency, DEFAULT_DATE_FORMAT } from '@aslanpay/portal-common-lib';

import { formatCurrency } from 'app/utils/strings';

export const formatSavingDate = (value?: string) =>
  value ? format(parseISO(value), DEFAULT_DATE_FORMAT) : '-';

export const formatSavingAmount = (value: number | undefined, currency: Currency) =>
  value == null ? '-' : formatCurrency(value, currency, 'en-GB');

export const localToday = (now = new Date()) => format(now, 'yyyy-MM-dd');
